(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pos-compatibility-submit"] && !Shopify.designMode) return;
  try {
    
  class PosCompatibilitySubmit extends HTMLElement {
    #ac;
    #currentSearchQuery = '';

    connectedCallback() {
      this.#ac = new AbortController();
      const { signal } = this.#ac;

      const trigger = this.querySelector('.pos-compat-submit__trigger');
      const modal = this.querySelector('.pos-compat-submit__modal');
      const closeBtn = this.querySelector('.pos-compat-submit__close');
      const form = this.querySelector('.pos-compat-submit__form');
      const deviceNameInput = this.querySelector('.pos-compat-submit__device-name');
      const confirmedEl = this.querySelector('.pos-compat-submit__confirmed');
      const submitBtn = this.querySelector('.pos-compat-submit__btn');

      if (!modal) return;

      document.addEventListener('pos-compat:search', e => {
        this.#currentSearchQuery = e.detail.query;
      }, { signal });

      const openModal = () => {
        if (deviceNameInput && this.#currentSearchQuery) {
          deviceNameInput.value = this.#currentSearchQuery;
        }
        modal.showModal();
      };

      trigger?.addEventListener('click', openModal, { signal });
      closeBtn?.addEventListener('click', () => modal.close(), { signal });
      modal.addEventListener('click', e => {
        if (e.target === modal) modal.close();
      }, { signal });

      if (!form) return;

      form.addEventListener('submit', async e => {
        e.preventDefault();
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }

        const endpoint = form.dataset.endpoint;
        if (!endpoint) {
          console.error('[pos-compat-submit] No form endpoint URL configured');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          }
          return;
        }

        try {
          const fd = new FormData(form);
          await fetch(endpoint, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              name: fd.get('name'),
              email: fd.get('email'),
              device_name: fd.get('device_name'),
              device_type: fd.get('device_type'),
              notes: fd.get('notes'),
            }),
          });

          modal.close();
          form.reset();
          if (confirmedEl) confirmedEl.hidden = false;
        } catch (err) {
          console.error('[pos-compat-submit] Submit failed:', err);
          if (submitBtn) {
            const label = submitBtn.querySelector('.pos-compat-submit__btn-label');
            const originalText = label ? label.textContent : '';
            if (label) label.textContent = submitBtn.dataset.errorLabel;
            setTimeout(() => {
              if (label) label.textContent = originalText;
            }, 3000);
          }
        } finally {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          }
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.#ac?.abort();
    }
  }

  if (!customElements.get('pos-compatibility-submit')) {
  customElements.define('pos-compatibility-submit', PosCompatibilitySubmit);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
  const mq = window.matchMedia('(max-width: 749px)');

  document.querySelectorAll('.social-proof__grid').forEach((grid) => {
    const wrapper = grid.closest('.social-proof__grid-wrapper');
    if (!wrapper) return;

    let controller = null;

    const update = () => {
      const { scrollLeft, scrollWidth, clientWidth } = grid;
      wrapper.classList.toggle('show-left-fade', scrollLeft > 0);
      wrapper.classList.toggle('show-right-fade', scrollLeft < scrollWidth - clientWidth - 1);
    };

    const enable = () => {
      if (controller) return;
      controller = new AbortController();
      grid.addEventListener('scroll', update, { passive: true, signal: controller.signal });
      update();
    };

    const disable = () => {
      controller?.abort();
      controller = null;
      wrapper.classList.remove('show-left-fade', 'show-right-fade');
    };

    mq.addEventListener('change', (e) => e.matches ? enable() : disable());

    if (mq.matches) enable();
  });

  } catch(e) { console.error(e); }
})();
})();
